import Component from '../abstracts/Component';
import ChatUtils from '../utils/ChatUtils';

/**
 Chat component
 */
export default class ChatComponent extends Component {

  constructor() {
    super();
  }

  bindEvents() {
    // listen to events

    // prechatOpened
    this.$on('prechatOpened', (e) => {
      // launch select2 js
      const $selectEl = $('.subjectSelect select');
      $selectEl.each(function () {
        let ctx =  $(this);
        ctx.select2({
          minimumResultsForSearch: Infinity
        });
        ctx.on("select2:open", function(e) {
          // i need the z-index
          let sselect = document.querySelector('.select2-dropdown');
          if (sselect != null) {
            let sselectWrapper = sselect.closest('.select2-container ');
            if (sselectWrapper != null) {
              sselectWrapper.style['z-index'] = '9999';
            }
          }
          // prevent body scrolling
          $('body .select2-dropdown ul').on( 'mousewheel DOMMouseScroll', function (e) {
            var e0 = e.originalEvent;
            var delta = e0.wheelDelta || -e0.detail;
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
          });
        });
        // change the subject
        ctx.on("select2:selecting", function(e) {
          // target
          let subjectSelect = document.querySelector('.embeddedServiceSidebar .fieldList #LiveChat_Subject__c');
          if (subjectSelect == null) {
            subjectSelect = document.querySelector('.embeddedServiceSidebar .fieldList #Type');
          }
          if (subjectSelect == null) {
            subjectSelect = document.querySelector('.embeddedServiceSidebar .fieldList #Subject');
          }
          // value
          var data = e.params.args.data.id;
          subjectSelect.value = data;
          // launch event
          var evt = document.createEvent("Events");
          evt.initEvent("change", true, true);
          subjectSelect.dispatchEvent(evt);
        });

      });

    });

    //
    var chatButton = $('a[data-name=live-chat]');
    // button online
    this.$on('chatButtonEnabled', (e) => {
      chatButton.removeClass('not-available').addClass('available');
    });
    // button offline
    this.$on('chatButtonDisabled', (e) => {
      chatButton.removeClass('available').addClass('not-available');
    });


  }


  /////
  render() {
    this.log('rendering...');
    // some events
    this.bindEvents();
    // check if new chat is enabled
    let chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
    // if is enabled let's launch it
    if (chatEnabled == 'true') {
      // script call
      let script = ChatUtils.getValue('urlEnvironmentSF')+'/embeddedservice/5.0/esw.min.js';
      // get script and initialize chat
      this.moduleLoader.loadExternalScript(script).then(() => {
        this.log('loading...');
        // subjects
        let subjects = {
          chatLabelSubject: '',
          chatLabelSubjectOptionOD: 'Orders and deliveries',
          chatLabelSubjectOptionPay: 'Payment, promotions and Gift Cards',
          chatLabelSubjectOptionCS: 'Comments and Suggestions',
          chatLabelSubjectOptionPAv: 'Product information and availability',
          chatLabelSubjectOptionSt: 'Stores',
          chatLabelSubjectOptionRR: 'Refunds and Returns',
          chatLabelSubjectOptionTA: 'Technical assistance'
        }
        // if is present the conf, i add the PS
        if (ChatUtils.getValue('personalStylistSnapConfig')) {
          subjects = ChatUtils.addToObject(subjects,'chatLabelSubjectOptionPS','Personal Stylist',1);
        }
        // general options
        let options = {
          selectors: {
            startChatLink: '[data-name=live-chat] a',
            personalStylistCloseBtn: '.live-chat-personal-stylist-cta .icon-close',
          },
          subjects: subjects
        }
        // setup env
        ChatUtils.setEnvironment(options);
        // update cookie path
        ChatUtils.updatePath();
        // init the chat
        ChatUtils.initializeChat();
        // new chat modifier
        ChatUtils.runsNewChat();
        //
        ChatUtils.checkReappearancePersonalStylistPopUp();
      });
    }
  }
}
